import React from "react";
import useSWR from "swr";
import { fetchPostDetails, submitAnswer } from "./fetchers";
import apple from "./apple_logo_black.svg";

function App() {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const userName = urlSearchParams.get("userName");
  const userPhoto = urlSearchParams.get("userPhoto");
  const userId = urlSearchParams.get("userId") || "";
  const postId = urlSearchParams.get("postId") || "";
  const questionId = urlSearchParams.get("questionId") || "";
  const hasAllData = userId.length && postId.length && questionId.length;
  const { data: post } = useSWR(
    hasAllData ? fetchPostDetails.key : null,
    async () => {
      if (hasAllData) {
        return fetchPostDetails.fetcher(postId, userId);
      }
    }
  );
  return (
    <div>
      <div className="uk-flex uk-flex-middle uk-flex-center uk-background-primary">
        {userPhoto && (
          <img
            className="uk-border-circle uk-margin-left uk-margin-right"
            src={userPhoto}
            style={{ height: 44, width: 44 }}
          />
        )}
        {userName && (
          <span
            className="uk-text-white"
            style={{ fontSize: 12, paddingTop: 10, paddingBottom: 10 }}
          >
            {userName} has requested your help placing a bet. Answer the
            following question and send them your prediction! ✌️✌️✌️
          </span>
        )}
      </div>
      <div
        data-uk-height-viewport="expand: true"
        className="uk-background-muted"
      >
        {post && (
          <GameQuestion
            post={post}
            questionId={questionId}
            userId={userId}
            userName={userName}
          />
        )}
      </div>
    </div>
  );
}

export default App;

type Question = {
  id: string;
  media: {
    imageUrl: string;
  };
};

const GameQuestion = ({
  post,
  questionId,
  userId,
  userName,
}: {
  post: any;
  questionId: string;
  userId: string;
  userName: string;
}) => {
  const [selected, setSelected] = React.useState("");
  const [submitStatus, setSubmitStatus] = React.useState("");
  const question = post.questions.find((q: Question) => q.id === questionId);
  const submit = async () => {
    if (!selected.length) {
      alert("Get choosin' to move on");
      return;
    } else {
      const option = question.options.find((o) => o.id === selected);
      const data = await submitAnswer({
        userId,
        postId: post.id,
        questionId,
        optionId: option.id,
        text: option.text,
      }).catch(() => {
        alert("Please try again!");
      });
      setSubmitStatus("submitted");
    }
  };
  return (
    <div className="uk-flex uk-flex-center">
      <div style={{ maxWidth: 500 }}>
        <img src={question.media.imageUrl} style={{ width: "100%" }} />
        <div
          style={{
            backgroundColor: "white",
            borderTopLeftRadius: 10,
            borderTopRightRadius: 10,
            paddingLeft: 20,
            paddingRight: 20,
            paddingTop: 17,
            paddingBottom: 17,
          }}
        >
          <span
            style={{
              fontSize: 20,
              letterSpacing: 0.3,
              color: "rgb(38, 38, 38)",
            }}
          >
            {question.text}
          </span>
        </div>
        {question.options.map((option, index) => (
          <div
            key={option.id}
            style={{ marginTop: 20, marginLeft: 20, marginRight: 20 }}
          >
            <button
              className="uk-button uk-button-default uk-button-large uk-padding-remove uk-width-expand"
              style={{ borderWidth: 0, textTransform: "none" }}
              onClick={() => setSelected(option.id)}
            >
              <div className="uk-flex">
                <div
                  className="uk-flex uk-flex-center uk-flex-middle uk-height-expand"
                  style={{
                    width: 60,
                    backgroundColor:
                      submitStatus === "submitted"
                        ? "rgb(255, 120, 125)"
                        : selected === option.id
                        ? "rgb(113, 248, 207)"
                        : "rgb(255, 120, 125)",
                    borderTopLeftRadius: 10,
                    borderBottomLeftRadius: 10,
                  }}
                >
                  {submitStatus === "submitted" ? (
                    <span className="uk-text-white">
                      {(option.probability * 100).toFixed(0)}%
                    </span>
                  ) : (
                    <span className="uk-text-white" style={{ fontSize: 22 }}>
                      {index + 1}
                    </span>
                  )}
                </div>
                <div
                  className="uk-flex uk-flex-center uk-flex-middle uk-width-expand uk-height-1-1"
                  style={{
                    backgroundColor: "white",
                    borderTopRightRadius: 10,
                    borderBottomRightRadius: 10,
                    position: "relative",
                  }}
                >
                  <div
                    className="uk-height-1-1"
                    style={{
                      position: "absolute",
                      left: 0,
                      width:
                        submitStatus === "submitted"
                          ? `${option.probability * 100}%`
                          : 0,
                      backgroundColor: "rgba(255, 120, 125, 0.56)",
                    }}
                  />
                  <span className="uk-margin-left uk-margin-right">
                    {option.text}
                  </span>
                </div>
              </div>
            </button>
          </div>
        ))}
        {submitStatus !== "submitted" ? (
          <div
            className="uk-flex uk-flex-row uk-flex-right uk-padding-small"
            style={{ marginBottom: 20, marginRight: 10 }}
          >
            <button
              className="uk-button uk-button-default"
              style={{
                borderRadius: 5,
                backgroundColor: "white",
                borderWidth: 0,
                textTransform: "none",
              }}
              onClick={submit}
            >
              Send
            </button>
          </div>
        ) : (
          <div
            className="uk-flex uk-flex-column uk-flex-middle uk-padding-small"
            style={{ marginBottom: 20, marginLeft: 20, marginRight: 20 }}
          >
            <p className="uk-text-center" style={{ fontSize: 17 }}>
              Wheew! Thanks for your answer, it's been sent to {userName}.
              Download Goss now to play for prizes.
            </p>
            <div className="uk-flex uk-flex-center">
              <a
                href="https://apps.apple.com/us/app/goss-media/id1498219571"
                className="uk-margin-right"
              >
                <img src="/app_store.png" style={{ height: 30 }} />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.goss"
                className="uk-margin-left"
              >
                <img src="/play_store.png" style={{ height: 30 }} />
              </a>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
